export default __webpack_public_path__ + "img/caret-up.04fd47ea.svg";